import { fetch } from "../utils/scsFetch";
import { URL_SURVEY_API, REACT_APP_URL_SURVEY_API_EXT } from '../utils/constEnvVariables'


export function getSuppliersByCriteria(inputValue, accessToken, companyType, abortSignal) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        signal: abortSignal
    }

    return fetch(`${URL_SURVEY_API}/surveys/filters/supplier/${companyType}/${inputValue}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { console.log(error) });
}

export function getContactByCriteria(inputValue, accessToken, companyType, abortSignal) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        signal: abortSignal
    }

    return fetch(`${URL_SURVEY_API}/surveys/filters/contact/${companyType}/${inputValue}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export function getSurveyTypes(accessToken) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/filters/surveyTypes`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export function getFilterResults(filterOptions, accessToken, isEmployee, abortSignal){
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: filterOptions,
        signal: abortSignal
    }
    const url = isEmployee 
              ? `${REACT_APP_URL_SURVEY_API_EXT}/surveys/filters/filteredData`
              : `${URL_SURVEY_API}/surveys/filters/filteredSupplierData` 

    return fetch(url, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}
